import React, { createElement, Fragment } from 'react';
import Search from '@ifeng-fe/ui_pc_search';
import Style from './index.module.scss';
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip'
import Chip from 'Chip';

export interface PageNav_1_Props {
    nodeId?: string
    style?: object;
    navChip: TYPE_Chip;
}

const PageNav_1: React.FC<PageNav_1_Props> = (props) => {
    const { nodeId, navChip, style } = props;

    const structData = useChip(navChip);
    const searchData = useChip({
        title: '搜索data',
        id: '20005',
        type: 'struct',
        force: '',
    });
    const structChipComponentData = formatChip(navChip)

    const { logo = {}, bread, navs } = structData;

    return (
        <Chip {...structChipComponentData}>
            <div id={nodeId} className={Style.wrap} style={style}>
                <div className={Style.wrapLeft}>
                    {Object.keys(structData).length > 0 && (
                        <Fragment>
                            {logo && logo.img ? (
                                <div className={Style.logo}>
                                    {logo.link ? (
                                        <a href={logo.link}>
                                            <img
                                                src={logo.img}
                                                alt=""
                                                style={{
                                                    width: logo.width || 'auto',
                                                    height: logo.height || 'auto',
                                                }}
                                            />
                                        </a>
                                    ) : (
                                        <img
                                            src={logo.img}
                                            alt=""
                                            style={{
                                                width: logo.width || 'auto',
                                                height: logo.height || 'auto',
                                            }}
                                        />
                                    )}
                                </div>
                            ) : null}
                            <div className={Style.list}>
                                {bread && Array.isArray(bread) && bread.length ? (
                                    <div className={Style.bread}>
                                        {bread.map((item, index, array) => {
                                            const { link, text } = item;

                                            return (
                                                <Fragment>
                                                    <a href={link} target="_blank">
                                                        {text}
                                                    </a>
                                                    {index < array.length - 1 ? <span>|</span> : null}
                                                </Fragment>
                                            );
                                        })}
                                    </div>
                                ) : null}
                                {navs && Array.isArray(navs) && navs.length ? (
                                    <div className={Style.navs}>
                                        {navs.map((item) => {
                                            const { link, text } = item;

                                            return (
                                                <span>
                                                [
                                                <a href={link} target="_blank">
                                                    {text}
                                                </a>
                                                ]
                                            </span>
                                            );
                                        })}
                                    </div>
                                ) : null}
                            </div>
                        </Fragment>
                    )}
                </div>
                <div className={Style.wrapRight}>
                    {Object.keys(searchData).length > 0 && <Search content={searchData} />}
                </div>
                <Mask visible={!navChip.id} zIndex={3}>
                    示例结构化碎片—{navChip.default.id}
                </Mask>
            </div>
        </Chip>
    );
};

export default PageNav_1;
